import styled, { css } from "styled-components";
import { Text, Heading, List, ButtonSettings, Selector, Icon } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const SettingsPageStyled = styled.section`
  padding: ${props => props.theme.baseLayoutPaddingBs}%;
  padding-top: 3%;
`;

export const TextDisclaimerStyled = styled(Text)`
  letter-spacing: 0rem;
`;
export const TextDeviceManagementStyled = styled(Text)`
  line-height: ${props => props.theme.font.lineHeight.large};
  margin-bottom: ${props => props.theme.spacing.xmedium} !important;
`;

export const ProfileNameStyled = styled(Text)`
  font-weight: ${props => props.theme.font.weight.semiBold};
  line-height: ${props => props.theme.font.lineHeight.xsmall};
  margin-bottom: 0;
`;
export const ProfileSubtextStyled = styled(Text)`
  color: ${props => props.theme.color.greyLight};
  font-size: ${props => props.theme.font.size.small};
`;
export const BlockStyled = styled.div`
  & {
    width: 36%;
  }
  & + & {
    width: 57%;
    text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")};
    margin-top: -5rem;
  }
`;

export const HeadingStyled = styled(Heading)`
  margin-bottom: ${props => props.theme.spacing.small};
`;

export const SettingsHeading = styled(Heading)`
  margin-bottom: ${props => props.theme.spacing.xmedium};
  margin-top: 0;
  text-transform: capitalize;
`;

export const ListInfoStyled = styled(List)`
  position: absolute;
  bottom: ${props => props.theme.baseLayoutPaddingBs * 2}%;
`;

export const ListInfoSettingsStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: ${props => props.theme.spacing.xmedium};
  color: ${props => props.theme.color.greyLight};
`;
export const BuildItemStyled = styled.div`
  margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}:${props =>
  props.theme.spacing.xxsmall};
  font-size: ${props => props.theme.font.size.small};
  color: ${props => props.theme.color.white};
  line-height: ${props => props.theme.font.lineHeight.medium};
  &:last-child {
   margin-right: 0; 
  }
`;
export const ItemStyled = styled.p``;
export const LogoStyled = styled.div`
  ${props => `text-align: ${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right"}`};
`;

export const LogoImg = styled.img`
  width: 14.84vw;
  height: 2.1vw;
`;

export const ListStyled = styled.div`
  width: 98%;
  text-align: start;
  padding: 0.5rem 1rem 1rem 1rem;
  height: 6.5rem;
  margin: 0rem 0rem 1rem;
  p {
    margin-bottom: 0rem;
    line-height: 2.5rem;
  }
  p:first-child {
    color: ${props => props.theme.color.grey};
  }
  .keyHeading {
    line-height: 2.25rem;
  }
  border-radius: 0.5rem;
  background-color: ${props => props.theme.color.secondary};
`;

const wrapperStyles = {
  wrapperStyles: css`
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    > * {
      margin-bottom: 0.8rem;
    }
  `
};

const headerTextStyles = {
  styles: css`
    font-weight: ${props => props.theme.font.weight.semiBold};
  `
};
export const ProfileWrapper = styled.div`
  ${wrapperStyles.wrapperStyles};
  width: 100%;
`;
export const AccountDetailsWrapper = styled.div`
  ${wrapperStyles.wrapperStyles};
  width: 100%;
`;

export const LanguageWrapper = styled.div`
  ${wrapperStyles.wrapperStyles};
  width: 50%;
`;

export const LogoutWrapper = styled.div`
  ${wrapperStyles.wrapperStyles};
  width: 50%;
  margin: 0;
`;

export const LogoutSubtextStyled = styled(Text)`
  white-space: nowrap;
`;
export const DevicesWrapper = styled.div`
  ${wrapperStyles.wrapperStyles};
  width: 100%;
`;

export const HistoryListWrapper = styled.div`
  ${wrapperStyles.wrapperStyles};
  width: 100%;

  .heading {
    margin-bottom: 0.6rem;
    // font-size: 2rem;
  }
`;

export const HeaderText = styled(Text)`
  ${headerTextStyles.styles};
  margin: ${props => props.theme.spacing.xxsmall} 0 0 0 !important;
`;
export const HeaderTextStyled = styled(Text)`
  ${headerTextStyles.styles};
`;
export const StepText = styled(Text)`
  vertical-align: middle;
  font-weight: ${props => props.theme.font.regular};
  display: inline-block;
  // margin-bottom: 0rem;
  margin: ${props => props.theme.spacing.xsmall} 0 ${props => props.theme.spacing.xmedium} 0;
`;

export const ParentalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;
  > * {
    margin-bottom: 0.8rem;
  }

  .restricted {
    line-height: 1.2;
  }
`;
export const IconWrapperStyled = styled.div`
  position: relative;
  display: inline-block;
  width: fit-content;
  margin-bottom: ${props => props.theme.spacing.xxsmall};
`;
export const SubHeaderTextStyled = styled(Text)`
  line-height: ${props => props.theme.font.lineHeight.xlarge};
  margin-bottom: 1rem;
`;
export const LockIconWrapperStyled = styled.div`
  display: flex;
  align-items: end;
  margin-bottom: ${props => props.theme.spacing.default};
`;
export const IconStyled = styled(Icon)`
  width: ${props => props.theme.font.size[props.width]};
  height: ${props => props.theme.font.size[props.height]};
  fill: ${props => props.theme.color.white};
  margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: ${props =>
  props.theme.spacing.xsmall};
`;
export const ImageStyled = styled.img`
  border-radius: 50%;
  width: 8rem;
  height: 8rem;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.24);
`;

export const LineSeparator = styled.div`
  position: absolute;
  border-right: 2px solid ${props => props.theme.color.greyLight};
  top: 18vh;
  ${props => `${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left"}: 39rem`};
  height: 70vh;
  opacity: 0.2;
`;

export const Spacer = styled.div`
  margin-bottom: ${props => (props.mb ? `${props.mb}rem` : "2rem")};
`;

export const AccountStatusWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

export const TextChannelsStyled = styled(Text)`
  margin-bottom: ${props => props.theme.spacing.xlarge};
`;

export const HistoryWrapper = styled.div`
  ${wrapperStyles.wrapperStyles};
  width: 78%;
  margin: 0;

  ul {
    width: 60%;
    //margin: 0 auto;
  }
`;

export const ButtonModalStyled = styled(ButtonSettings)`
  display: block;
  margin-top: ${props => props.theme.spacing.xsmall};
  width: 20%;
  margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: auto;
`;
export const ButtonAccountDetailStyled = styled(ButtonSettings)`
  display: inline;
  margin-top: ${props => props.theme.spacing.xsmall};
  width: 42%;
  margin:1.5rem 1.5rem 0 0 !important;
  // background:${props => props.theme.color.shadeBlack}
  //margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: auto;
`;

export const GuidTextWrapperStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  height: 29px;
  width: 100%;
  margin-top: 3.375rem;
  position: absolute;
  ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: 3.7rem;
`;

export const GuidHeadingStyled = styled(Text)`
  color: #d1d3d4;
  &&& {
    letter-spacing: 0;
  }
`;
export const GuidTextStyled = styled(Text)`
  color: #ffffff;
  padding-left: 5px;
  &&& {
    letter-spacing: 0;
  }
`;
export const ListItemWrapper = styled.ul`
  text-align: ${props => (props.theme.locale.dir === "rtl" ? "right" : "left")};
  height: 32rem;
  overflow: hidden;
`;
export const SelectorStyled = styled(Selector)`
  display: flex;
`;
export const KidsProfileLogoContainer = styled.div`
  height: 100%;
  position: absolute;
  top: 0;
`;
export const KidsProfileLogo = styled.img`
  height: 100%;
  width: 100%;
`;
